import StickyTemplate from './vendor/StickyTemplate/1.0/StickyTemplate';

const $ = window.$;

export default class PopupInfo {
  constructor(content, position, delay = 0) {
    const $container = (this.$container = StickyTemplate.jq('popup-info'));
    const $parent = $('#app');

    $container.css({
      left: position.left,
      top: position.top,
    });

    this.setContent(content);

    if (delay > 0) {
      this.timeout = setTimeout(() => {
        $parent.append($container);
        this.checkPosition();
      }, delay);
    } else {
      $parent.append($container);
      this.checkPosition();
    }
  }

  checkPosition() {
    const offsetLeft = this.$container.offset().left;
    const posRight = offsetLeft + this.$container.outerWidth();
    const windowRight = window.innerWidth;

    if (posRight - windowRight > 0) {
      this.$container.css({
        left: offsetLeft - posRight - windowRight,
      });
    }
  }

  setContent = content =>
    this.$container.append(
      StickyTemplate.jq('popup-info-content', { '%content%': content }),
    );

  close = () => {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    this.$container.fadeOut(100, () => this.$container.remove());
  };
}
